import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import {
    OrganizationCenterPersonGridObject,
    OrganizationCenterPersonObject,
} from '@libs/types/src/organization/object-type/organization-center-person.object';
import { CreateOrganizationPersonInput, OkObject, UpdateOrganizationPersonInput } from '@it2go/types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import {
    CenterPersonSelectInput,
} from '@libs/types/src/organization/input-type/organization-person/center-person.select-input';
import { CenterManagersReplaceInput } from '@libs/types/src/organization/input-type/organization-person/center-managers.replace-input';

@Injectable({ providedIn: 'root' })
export class OrganizationCenterPersonGqlService extends GqlServiceV2 {

    public getOrganizationCenterPersons(input: GridInput, fragment: string) {
        return this.query<OrganizationCenterPersonGridObject>(
            `
                query($input: GridInput) {
                    organizationPerson {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createOrganizationCenterPerson(input: CreateOrganizationPersonInput, fragment = 'id') {
        return this.mutate<OrganizationCenterPersonObject>(
            `
                mutation($input: CreateOrganizationPersonInput!) {
                    organizationPerson {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateOrganizationCenterPerson(input: UpdateOrganizationPersonInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: UpdateOrganizationPersonInput!) {
                    organizationPerson {
                        update(input: $input) {
                           ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteOrganizationCenterPerson(input: IdInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    organizationPerson {
                        delete(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public selectOrganizationCenterPerson(input: CenterPersonSelectInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: CenterPersonSelectInput!) {
                    organizationPerson {
                        select(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public replaceOrganizationCenterManagers(input: CenterManagersReplaceInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: CenterManagersReplaceInput!) {
                    organizationPerson {
                        replaceManagers(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

}
